import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { User } from '../../models/user';
import { Session } from '../../models/session';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {
  public user: User;

  constructor(
    private router: Router,
    public activeModal: NgbActiveModal,
  ) {
   }

  ngOnInit() {
  }

  closeModal() {
    this.activeModal.close('x');
    this.activeModal.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/logout/logout.component.ts